import React, { useState, useEffect, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import FallbackSpinner from './components/FallbackSpinner';
/* eslint-disable import/no-cycle */
import NavBarWithRouter from './components/NavBar';
import Home from './components/Home';
// import Page404 from './components/Page404';
import endpoints from './constants/endpoints';

export const initialLanguage = 'en';

function MainApp() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(endpoints.routes, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => err);
  }, []);

  return (
    <div className="MainApp">
      <main className="main">
        <Switch>
          <Suspense fallback={<FallbackSpinner />}>
            <NavBarWithRouter />
            <Route exact path="/" component={Home} />
            {data
              && data.sections.map((route) => {
                const SectionComponent = React.lazy(() => import('./components/' + route.component));
                return (
                  <Route
                    key={route.headerTitle}
                    path={route.path}
                  >
                    <SectionComponent header={route.headerTitle} />
                  </Route>
                );
              })}
            {/* <Route
              path="/404"
            >
              <Page404 header="Not Found" />
            </Route>
            <Route
              exact
              path="*"
            >
              <Redirect to="/404" />
            </Route> */}
          </Suspense>
        </Switch>
      </main>
    </div>
  );
}

export default MainApp;
